import { cn } from "@/lib/utils";

export interface StepDef {
  label: string;
}

export function StepIndicatorV2({
  steps,
  activeIndex,
  className,
  ariaLabel = "Wizard adimlari",
}: {
  steps: StepDef[];
  activeIndex: number;
  className?: string;
  ariaLabel?: string;
}) {
  return (
    <nav aria-label={ariaLabel} className={cn("w-full", className)}>
      <ol className="flex items-center gap-1">
        {steps.map((step, idx) => {
          const done = idx < activeIndex;
          const active = idx === activeIndex;
          return (
            <li
              key={step.label}
              aria-current={active ? "step" : undefined}
              className="flex flex-1 items-center gap-1"
            >
              <div className="flex flex-col items-center gap-1">
                <div
                  className={cn(
                    "flex h-8 w-8 items-center justify-center rounded-full text-xs font-bold transition",
                    done && "v2-step-done",
                    active &&
                      "border-2 border-[var(--v2-accent)] text-[var(--v2-accent)]",
                    !done &&
                      !active &&
                      "border border-[var(--v2-border)] text-[var(--v2-text-muted)]"
                  )}
                >
                  {done ? "✓" : idx + 1}
                </div>
                <span
                  className={cn(
                    "text-center text-[11px] leading-tight",
                    active
                      ? "font-semibold text-[var(--v2-text-strong)]"
                      : "text-[var(--v2-text-muted)]"
                  )}
                >
                  {step.label}
                </span>
              </div>
              {idx < steps.length - 1 ? (
                <div
                  className={cn(
                    "mx-1 hidden h-px flex-1 sm:block",
                    done ? "v2-step-line-done" : "v2-step-line-pending"
                  )}
                />
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
